export default "__VITE_PUBLIC_ASSET__66c1f817__"